<template>
	<!-- Shape of pages/podcasts-index.vue: latest-episodes rotator, then podcast card grid. -->
	<div aria-hidden="true">
		<!-- Latest episodes rotator -->
		<Skeleton rounded="rounded-none" class="w-full h-[40vh] md:h-[55vh]" />

		<!-- Podcast cards grid -->
		<div class="max-w-9xl mx-auto grid grid-cols-2 md:grid-cols-3 xl:grid-cols-4 gap-4 sm:gap-12 p-4 py-8 sm:p-12 md:py-16">
			<div v-for="n in 8" :key="n" class="w-full border dark:border-gray-800 shadow-card">
				<Skeleton rounded="rounded-none" class="w-full aspect-square" />
				<div class="p-4">
					<Skeleton class="h-4 md:h-5 w-3/4" />
					<Skeleton class="h-3 w-full mt-3" />
					<Skeleton class="h-3 w-5/6 mt-2" />
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import Skeleton from '../skeleton.vue'

export default {
	name: 'PodcastsSkeleton',
	components: { Skeleton },
}
</script>
